import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyYen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 19v-7m0 0L7 5m5 7 5-7M8 17h8m-8-4h8"
    />
  </svg>
);
export default SvgCurrencyYen;
